import classNames from "classnames";
import React, { FunctionComponent } from "react";
import { IntlShape, useIntl } from "react-intl";
import { ReactComponent as IconFacebook } from "../../../../icons/facebook.svg";
import { ReactComponent as IconFriendsSharing } from "../../../../icons/friends_sharing.svg";
import { ReactComponent as IconGoogleMonochrome } from "../../../../icons/google-monochrome.svg";
import { ReactComponent as IconImage } from "../../../../icons/image.svg";
import { ReactComponent as IconImages } from "../../../../icons/images.svg";
import { ReactComponent as IconInstagram } from "../../../../icons/instagram.svg";
import { ReactComponent as IconSmartphone } from "../../../../icons/smartphone.svg";
import { SelectionProvider } from "../../../../types/selection/selection";
import PanelMenuItem from "../../customization/PanelMenuItem";
import "./style.scss";

const isNewGallery = process.env.REACT_APP_ACTIVATE_NEW_GALLERY === "true";

const SelectionHeaderProvider: FunctionComponent<{
  onClick: (provider: SelectionProvider) => void;
  provider: SelectionProvider;
  selected: boolean;
}> = ({ onClick, provider, selected }) => {
  const intl = useIntl();
  const { label, Icon } = getLabelAndIcon(provider, intl);

  return (
    <div className="SelectionHeaderProvider">
      {isNewGallery ? (
        <div
          className={classNames("SelectionHeaderProvider-button", {
            "SelectionHeaderProvider-button--active": selected,
          })}
          onClick={() => onClick(provider)}
        >
          <span className="SelectionHeaderProvider-button-icon">
            <Icon />
          </span>
          <span className="SelectionHeaderProvider-button-label">{label}</span>
        </div>
      ) : (
        <PanelMenuItem
          label={label}
          onClick={() => onClick(provider)}
          opened={selected}
          type={provider}
        />
      )}
    </div>
  );
};

export default SelectionHeaderProvider;

const getLabelAndIcon = (
  provider: SelectionProvider,
  intl: IntlShape
): { label: string; Icon: FunctionComponent } => {
  switch (provider) {
    case "upload":
      return {
        Icon: IconImages,
        label: intl.formatMessage({
          id: "kustom_selectionHeaderProvider_myPhotos",
        }),
      };
    case "unsplash":
      return { Icon: IconImage, label: "Unsplash" };
    case "friends_sharing":
      return {
        Icon: IconFriendsSharing,
        label: intl.formatMessage({
          id: "kustom_selectionHeaderProvider_friendsSharing",
        }),
      };
    case "facebook":
      return { Icon: IconFacebook, label: "Facebook" };
    case "instagram":
      return { Icon: IconInstagram, label: "Instagram" };
    case "google_photos":
      return { Icon: IconGoogleMonochrome, label: "Google" };
    case "mobile_upload":
      return {
        Icon: IconSmartphone,
        label: intl.formatMessage({
          id: "kustom_selectionHeaderProvider_phone",
        }),
      };
    default: {
      const exhaustiveCheck: never = provider;
      throw new Error(`Unsupported provider ${exhaustiveCheck as string}`);
    }
  }
};
